import React, { useCallback, useEffect, useRef, useState, memo } from 'react';
import styles from './CommentDetail.module.less';
import Reply from './Reply';
import UserHeader from '../../../static/forum_default_header.svg';
import Rate from '../../Rate/Rate';
import { formatNumber } from '../../../utils/utils';

import useLoginStatus, { handleLogin } from '../../../utils/hooks/useLoginStatus';
import Preview from '../../Preview/Preview';
import Tag from './Tag';
import V from '../../../static/comment_v.svg';
import VSmall from '../../../static/comment_v_small.svg';
import Guan from '../../../static/comment_guan.svg';
import GuanSmall from '../../../static/comment_guan_small.svg';
import { Popover } from 'antd';
import config from '../config';
import CommentOn from '../../CommentOn';
import getChildrenJSON from '../getChildrenJSON';
import getHtmlByNodeList from '../getHtmlByNodeList';
import Report from './Report';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../../actions/log';
import Toast from '../../Toast/Toast';
import Hot from '../../../static/comment_hot.svg';
import IconItem from './IconItem';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default memo(
  ({
    commentInfo,
    data,
    handleUpdate = () => {},
    requestInfo,
    releaseInfo,
    handleUpdateByEditor, //编辑器提交数据
    updateCommentOn, //记录最后一次点击回复的位置函数
    currCommentOn, //点击回复的位置
    commentTargetInfo,
  }) => {
    const [open, setOpen] = useState(false);
    const loginStatus = useLoginStatus();
    const limit = 3;
    const [previewInfo, setPreviewInfo] = useState({ show: false, active: 0 });
    const node = useRef(null);
    const [hasTask, setHasTask] = useState(false);
    const [showCommentOn, setShowCommentOn] = useState(false);
    const [commentDetail, setCommentDetail] = useState(null);
    const [showReport, setShowReport] = useState(false);
    const logInfoData = useSelector(selectLogInfo);
    const dispatch = useDispatch();

    const requestZan = useCallback(async () => {
      dispatch(
        logging({
          category: 'C',
          action: 'Detail_CommmentZan',
          label: '',
          param2: {
            source: logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            id: requestInfo?.bizIdentity?.replace('zt_', ''),
            commmentId: commentInfo?.id,
            softid: requestInfo?.version ? requestInfo?.bizIdentity : null,
            version: requestInfo?.version,
            type: requestInfo?.type,
          },
        }),
      );

      try {
        setHasTask(false);
        const res = await config.setCommentZan({
          bizIdentity: data?.bizIdentity,
          optType: '1',
          type: data?.type,
          commentId: commentInfo?.id,
          targetUserId: commentInfo?.userId,
        });
        if (res?.status == 0) {
          handleUpdate(res?.data);
        }
        if (res?.status == 200201) {
          handleUpdate({
            commentId: commentInfo?.id,
            zanCount: commentInfo?.datas?.zan,
          });
        }
      } catch (err) {
        //
      }
    }, [data, commentInfo, handleUpdate]);
    const handleZan = useCallback(() => {
      // 已经点过赞
      if (commentInfo?.hasZan === 1) {
        Toast.error({
          content: '您已经点过赞了',
        });
        return;
      }
      if (loginStatus) {
        requestZan();
      } else {
        setHasTask(true);
        handleLogin();
      }
    }, [data, commentInfo]);

    const handleUser = useCallback(
      json => {
        const temp = json.map(el => {
          if (el?.attrs && el?.attrs[0]?.name == 'data-user') {
            const target = releaseInfo?.mentionUsers?.find(
              item => item.userId === el?.attrs[0]?.value,
            );
            return {
              ...el,
              children: target?.nickName ? [`@${target.nickName}`] : el.children,
            };
          }
          return el;
        });

        return temp;
      },
      [releaseInfo],
    );

    const handleReport = useCallback(() => {
      setShowReport(true);
      dispatch(
        logging({
          category: 'C',
          action: 'Comment_Report',
          label: '',
          param2: {
            source: logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            commentId: commentInfo?.id,
            id: requestInfo?.bizIdentity?.replace('zt_', ''),
            version: requestInfo?.version,
            type: requestInfo?.type,
          },
        }),
      );
    }, []);

    const handleLogComment = useCallback(
      clickType => () => {
        dispatch(
          logging({
            category: 'C',
            action: 'Comment_Content',
            label: '',
            param2: {
              source: logInfoData.source,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              type: requestInfo.type,
              clickType,
              id: requestInfo?.bizIdentity?.replace('zt_', ''),
              version: requestInfo?.version,
            },
            // param3: data.bizInfo,
          }),
        );
      },
      [],
    );

    useEffect(() => {
      if (hasTask && loginStatus) {
        handleZan();
      }
    }, [loginStatus, hasTask]);

    useEffect(() => {
      try {
        const content = commentInfo?.contentInfo?.text
          ? commentInfo?.contentInfo?.text?.split('\n')?.join('<br/>')
          : '';
        const contentNode = document.createElement('div');
        contentNode.innerHTML = content || '';
        const json = getChildrenJSON(contentNode);
        const newJson = handleUser(json);
        setCommentDetail(getHtmlByNodeList(newJson)?.elems[0].innerHTML);
      } catch (err) {}
    }, [commentInfo]);

    if (
      !commentDetail &&
      (!commentInfo?.contentInfo?.labelCodes ||
        commentInfo?.contentInfo?.labelCodes?.length === 0) &&
      !commentInfo?.contentInfo?.imgs?.length &&
      [
        ...(commentInfo?.contentInfo?.appList || []),
        ...(commentInfo?.contentInfo?.specialList || []),
      ].length === 0
    ) {
      return null;
    }
    return (
      <>
        <div className={styles.comment_item} ref={node} data-id={commentInfo?.id}>
          <div className={styles.comment_user}>
            <div className={styles.comment_img}>
              <img className={styles.comment_img} src={commentInfo.profilePicUrl || UserHeader} />
              {commentInfo?.identity?.type && (
                <>
                  {commentInfo?.identity?.type === 1 && (
                    <img src={GuanSmall} className={styles.comment_img_v} />
                  )}
                  {commentInfo?.identity?.type === 3 && (
                    <img src={VSmall} className={styles.comment_img_v} />
                  )}
                </>
              )}
            </div>
            <div className={styles.comment_user_detail}>
              <div className={styles.comment_user_detail_line1}>
                <div className={styles.comment_user_detail_line1_name}>
                  {commentInfo?.nickName || '商店用户'}
                </div>
                {commentInfo?.identity?.type && (
                  <>
                    {commentInfo?.identity?.type === 1 && (
                      <div className={`${styles.comment_user_detail_line1_imgguan}`}>
                        <img src={Guan} />
                        <label>{commentInfo?.identity?.title}</label>
                      </div>
                    )}
                    {commentInfo?.identity?.type === 3 && (
                      <div className={`${styles.comment_user_detail_line1_imgv}`}>
                        <img src={V} />
                        <label>{commentInfo?.identity?.title}</label>
                      </div>
                    )}
                  </>
                )}
                {commentInfo?.achievements?.map(item => (
                  // <Popover
                  //   title={null}
                  //   content={<div className={styles.popover_text}>{item.name}</div>}
                  //   key={item.code}
                  //   overlayClassName={styles.achievements_item}
                  //   getPopupContainer={() => node.current}
                  // >
                  //   <img src={item.icon} className={`${styles.comment_user_detail_line1_img}`} />
                  // </Popover>
                  <IconItem info={item} key={item.code} />
                ))}
                {releaseInfo?.funcs?.indexOf('1') > -1 && (
                  <div className={styles.comment_user_detail_line1_rate}>
                    <Rate
                      score={commentInfo?.scoreInfo?.score || 1}
                      className={styles.comment_user_detail_line1_rate_star}
                      primary={true}
                    />
                  </div>
                )}
              </div>
              <div className={styles.comment_user_detail_line2}>
                <div className={`${styles.comment_user_detail_line2_time}`}>
                  {commentInfo?.updateTime || '刚刚'}
                </div>

                <div className={` ${styles.comment_user_detail_line2_sys}`}>
                  <i className={`iconfont icon-shebeixinxi`} />
                  {commentInfo?.deviceInfo?.mt || ''}
                </div>
                {/* <div className={styles.comment_top_time}>{commentInfo?.os || ''}</div> */}
              </div>
            </div>
            {releaseInfo?.commentSwitch === 0 && (
              <div className={styles.comment_operation}>
                <div className={styles.comment_opt}>
                  {/* <div className={styles.comment_opt_item} onClick={handleReport}>
                    <i className={`${styles.comment_opt_cion} iconfont icon-jubao`} />
                    <div className={styles.comment_opt_num}>举报</div>
                  </div> */}
                  <div className={styles.comment_opt_item} onClick={handleZan}>
                    <span
                      className={`${styles.comment_opt_cion} iconfont  ${
                        commentInfo.hasZan === 1 ? styles.comment_opt_cion_active : ''
                      } ${
                        commentInfo.hasZan === 1 ? styles.comment_opt_cion_zaned : 'icon-dianzan'
                      }`}
                    />
                    <div
                      className={`${styles.comment_opt_num} ${
                        commentInfo.hasZan === 1 ? styles.comment_opt_num_active : ''
                      }`}
                    >
                      {commentInfo.datas?.zan ? formatNumber(commentInfo.datas?.zan || 0) : '赞'}
                    </div>
                  </div>
                  <div
                    className={styles.comment_opt_item}
                    onClick={() => {
                      if (releaseInfo?.forbidden) {
                        Toast.error({
                          content: '您的账号已被禁言',
                        });
                        return;
                      }
                      if (!loginStatus) {
                        handleLogin();
                        return;
                      }
                      setShowCommentOn(true);
                      updateCommentOn({
                        commentInfo,
                      });
                    }}
                  >
                    <i className={`${styles.comment_opt_cion} iconfont icon-pinglun`} />
                    <div
                      className={styles.comment_opt_num}
                      onClick={e => {
                        e.target.scrollIntoView({ block: 'center' });
                      }}
                    >
                      回复
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className={styles.comment_content}>
            {releaseInfo?.funcs.indexOf('2') > -1 && (
              <div className={styles.comment_content_label}>
                {commentInfo?.contentInfo?.labelCodes?.map(item => {
                  return (
                    <div key={item.angleCode} className={styles.comment_content_label_item}>
                      #{item?.starLabels?.name}
                    </div>
                  );
                })}
              </div>
            )}

            {commentDetail && (
              <div
                className={styles.comment_content_detail}
                dangerouslySetInnerHTML={{
                  __html:
                    (commentInfo?.tags?.finalHot !== 0
                      ? `<img src='${Hot}'  height='16px' width='41px' style='margin-right:6px;vertical-align:middle;transform:translateY(-1px)' />`
                      : '') + (commentDetail || ''),
                }}
              />
            )}

            {commentInfo?.contentInfo?.imgs?.length > 0 && (
              <div className={styles.comment_content_imgs}>
                {commentInfo?.contentInfo?.imgs?.map((item, index) => (
                  <img
                    src={item}
                    key={index}
                    onClick={() => {
                      handleLogComment('img')();
                      setPreviewInfo({
                        ...previewInfo,
                        show: true,
                        active: index,
                      });
                    }}
                  />
                ))}
              </div>
            )}
            {[
              ...(commentInfo?.contentInfo?.appList || []),
              ...(commentInfo?.contentInfo?.specialList || []),
            ].length > 0 && (
              <div className={styles.comment_content_tags}>
                {[
                  ...commentInfo?.contentInfo?.appList,
                  ...commentInfo?.contentInfo?.specialList,
                ].map((item, index) => (
                  <div
                    className={styles.comment_content_tags_item}
                    key={index}
                    onClick={handleLogComment(item.ztId ? 'zt' : 'soft')}
                  >
                    <Tag data={item} type={item.ztId ? 'zt' : 'soft'} />
                  </div>
                ))}
              </div>
            )}
          </div>
          {showCommentOn &&
            !currCommentOn.replyInfo &&
            currCommentOn?.commentInfo?.id === commentInfo?.id && (
              <div className={styles.comment_editor}>
                <CommentOn
                  commentInfo={commentInfo}
                  hasScore={false}
                  requestInfo={requestInfo}
                  releaseInfo={releaseInfo}
                  handleUpdate={data => {
                    if (data) {
                      handleUpdateByEditor(data, commentInfo?.id, 'comment');
                    }
                    setShowCommentOn(false);
                  }}
                  commentTargetInfo={commentTargetInfo}
                />
              </div>
            )}
          {commentInfo?.replys?.length > 0 && (
            <div className={styles.comment_reply}>
              {(!open ? commentInfo?.replys?.slice(0, limit) : commentInfo?.replys || []).map(
                item => (
                  <Reply
                    comment={item}
                    key={item.id}
                    commentInfo={commentInfo}
                    data={data}
                    handleUpdate={handleUpdate}
                    requestInfo={requestInfo}
                    releaseInfo={releaseInfo}
                    handleUpdateByEditor={handleUpdateByEditor}
                    updateCommentOn={updateCommentOn}
                    currCommentOn={currCommentOn}
                    commentTargetInfo={commentTargetInfo}
                  />
                ),
              )}
              {commentInfo?.replys?.length > limit && !open && (
                <div
                  className={styles.comment_reply_btn}
                  onClick={() => {
                    setOpen(true);
                    dispatch(
                      logging({
                        category: 'C',
                        action: 'Comment_More',
                        label: '',
                        param2: {
                          source: logInfoData.source,
                          source_p: logInfoData.source_p,
                          source_pp: logInfoData.source_pp,
                          commentId: commentInfo?.id,
                        },
                        param3: data.bizInfo,
                      }),
                    );
                  }}
                >
                  查看全部{commentInfo?.replys?.length}条回复
                  <i className={`iconfont icon-point_right ${styles.reply} ${styles.reply_icon}`} />
                </div>
              )}
            </div>
          )}
        </div>

        {previewInfo.show && (
          <Preview
            data={commentInfo?.contentInfo?.imgs.map(item => ({ url: item, type: '0' }))}
            visible={true}
            activeIndex={previewInfo.active}
            close={() => {
              setPreviewInfo({ ...previewInfo, show: false });
            }}
          />
        )}
        {showReport && (
          <Report
            releaseInfo={releaseInfo}
            commentInfo={commentInfo}
            requestInfo={requestInfo}
            handleCancel={() => {
              setShowReport(false);
            }}
          />
        )}
      </>
    );
  },
);
